import styled, { css } from 'styled-components'

const baseTitle = css(
  ({ theme }) => `
    font-weight: ${theme.font.weight.semibold};
    line-height: 1.25;
    margin: 0;
  `
)

export const MainTitle = styled.h1(
  ({ theme }) => `
    ${baseTitle}
    font-size: 24px;

    @media (min-width: ${theme.media.tablet}) {
      font-size: 32px;
    }
  `
)

export const Title = styled.h2(
  ({ theme }) => `
    ${baseTitle}
    font-size: 20px;

    @media (min-width: ${theme.media.tablet}) {
      font-size: 24px;
    }
  `
)
